import http from './axios';

export interface AnalyzeCustomDto {
  id?: number;
  boardCode?: string;
  boardName?: string;
  boardDescription?: string;
  boardGroup?: string;
  boardLabel?: string;
  boardTool?: number;
  dataItem?: DataItem;
  indicatorInfo?: IndicatorInfo;
  status?: number;
}

export interface IndicatorInfo {
  boardTool?: number;
  dataDate?: string;
  endTime?: string;
  indicatorInfoList?: any;
  startTime?: string;
}

export interface DataItem {
  dataField?: string;
  groupByField?: string; // 预览时需要
  dimFieldCodes?: string; // 预览时需要
  dimensionList?: any;
  endTime?: string;
  measureList?: any;
  startTime?: string;
  subCode?: string;
}

export default class AnalyzeCustomServices {
  private readonly common_list_api = '/v1/analysis-board/common-list'; // 通用列表接口
  private readonly preview_api = '/v1/analysis-board/preview'; // 漏斗分析预览接口
  private readonly common_list_preview_api = '/v1/analysis-board/common-list-preview'; // 通用列表预览接口
  private readonly search_detail_api = '/v1/analysis-board/search-detail'; // 分析工具详情工具接口

  private readonly list_api = '/v1/analysis-board/list';
  private readonly info_api = '/v1/analysis-board/info';
  private readonly delete_api = '/v1/analysis-board/delete';
  private readonly update_api = '/v1/analysis-board/update';
  private readonly save_api = '/v1/analysis-board/save';

  constructor() {}

  async getCommonList(params?: { startTime: string; endTime: string; dataDate: string; boardCode: string; groupByField: string; dimFieldCodes: string }): Promise<any> {
    let res: any = await http.get(this.common_list_api, { params: params });
    return res.payload;
  }

  async funnelPreview(params?: IndicatorInfo) {
    let res: any = await http.post(this.preview_api, params);
    return res.payload;
  }

  async getCommonPreview(params?: DataItem): Promise<any> {
    let res: any = await http.post(this.common_list_preview_api, params);
    return res.payload;
  }

  async searchDetail(params?: { startTime: string; endTime: string; dataDate: string; boardCode: string }): Promise<any> {
    let res: any = await http.get(this.search_detail_api, { params: params });
    return res.payload;
  }

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getInfo(boardCode: any) {
    let res: any = await http.get(this.info_api + '/' + boardCode);
    return res.payload;
  }

  async add(data: AnalyzeCustomDto) {
    const params = { ...data, boardCode: 'ADB_' + data.boardCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: AnalyzeCustomDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.delete_api, [id]);
    return res.header?.code == 200;
  }
}
